import { configureStore, combineReducers, getDefaultMiddleware } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import queuesReducer from './queues-slice';
import positionsReducer from './positions-slice';

const rootReducer = combineReducers({
  queues: queuesReducer,
  positions: positionsReducer,
});

const middleware = getDefaultMiddleware<AppState>();

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger);
}

const store = configureStore({
  reducer: rootReducer,
  middleware,
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export default store;
